import { Box, styled } from '@mui/material';
import { DataGridProps, GridCellModes, GridCellModesModel, GridCellParams, DataGrid as MuiDataGrid } from '@mui/x-data-grid';
import React from 'react';

type Props = DataGridProps & {
  singleClick?: boolean;
};

const StyledDataGrid = styled(MuiDataGrid)(({ theme }) => ({}));

export const SummaryRow = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  marginTop: '16px',
}));

const DataGrid: React.FC<Props> = ({ singleClick = true, ...props }) => {
  const handleCellModesModelChange = (newModel: GridCellModesModel) => setCellModesModel(newModel);

  const [cellModesModel, setCellModesModel] = React.useState<GridCellModesModel>({});

  const handleCellClick = React.useCallback((params: GridCellParams, event: React.MouseEvent) => {
    if (!params.isEditable) {
      return;
    }

    // Ignore portal
    if ((event.target as any).nodeType === 1 && !event.currentTarget.contains(event.target as Element)) {
      return;
    }

    setCellModesModel((prevModel) => {
      return {
        // Revert the mode of the other cells from other rows
        ...Object.keys(prevModel).reduce(
          (acc, id) => ({
            ...acc,
            [id]: Object.keys(prevModel[id]).reduce(
              (acc2, field) => ({
                ...acc2,
                [field]: { mode: GridCellModes.View },
              }),
              {}
            ),
          }),
          {}
        ),
        [params.id]: {
          // Revert the mode of other cells in the same row
          ...Object.keys(prevModel[params.id] || {}).reduce((acc, field) => ({ ...acc, [field]: { mode: GridCellModes.View } }), {}),
          [params.field]: { mode: GridCellModes.Edit },
        },
      };
    });
  }, []);

  return (
    <StyledDataGrid
      {...props}
      disableColumnMenu
      disableColumnFilter
      density="comfortable"
      disableColumnSelector
      disableRowSelectionOnClick
      onCellClick={singleClick ? handleCellClick : undefined}
      cellModesModel={singleClick ? cellModesModel : undefined}
      onCellModesModelChange={singleClick ? handleCellModesModelChange : undefined}
      getCellClassName={(params) => (!params.colDef.editable && !(params.colDef.type === 'actions') ? 'cell--disabled' : '')}
    />
  );
};

export default React.memo(DataGrid);
